import GaugeComponent from 'react-gauge-component';

import { displayDecimal } from '../utils/display-scores.utils';

export function Co2InfographyCompact({
  items,
  colorScale,
  title,
}: {
  items: { score: number; label: string }[];
  colorScale: string[];
  title: string;
}) {
  const sum = items
    .filter((item) => item !== undefined)
    .reduce((acc, item) => acc + item.score, 0);
  const sortedItems = items.sort((a, b) => b.score - a.score);
  const sortedItemRatio = sortedItems.map((item) => ({
    ...item,
    score: item.score && sum ? (item.score / sum) * 100 : 0,
  }));
  return (
    <div
      style={{
        width: '100%',
        border: '1.5px solid #000',
        borderRadius: '12px',
        paddingBottom: '8px',
        fontWeight: 400,
        fontFamily: 'Darker Grotesque Variable',
        color: '#322222',
        fontSize: '11px',
      }}
    >
      <h2
        style={{
          display: 'flex',
          flexDirection: 'column',
          color: '#322222',
          borderBottom: '1px solid #000',
          fontSize: '14px',
          fontWeight: 700,
          padding: '1px 20px 13px 20px',
          lineHeight: '16px',
          wordWrap: 'break-word',
          width: '100%',
          textAlign: 'left',
        }}
      >
        {title}
      </h2>
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
        }}
      >
        <CamembertGauge items={sortedItemRatio} colorScale={colorScale} />
        <InfographyLegend items={sortedItemRatio} colorScale={colorScale} />
      </div>
    </div>
  );
}

export function CamembertGauge({
  items,
  colorScale,
}: {
  items: { score: number; label: string }[];
  colorScale: string[];
}) {
  const subArcs = items.map((item) => ({ length: item.score / 100 }));
  const colorArray = items.map((item) =>
    getColorFromPercentage(item.score, colorScale),
  );

  return (
    <GaugeComponent
      style={{ width: '220px' }}
      value={100}
      type="semicircle"
      labels={{
        valueLabel: {
          hide: true,
        },
        tickLabels: {
          type: 'outer',
          ticks: [
            { value: 10 },
            { value: 20 },
            { value: 30 },
            { value: 40 },
            { value: 50 },
            { value: 60 },
            { value: 70 },
            { value: 80 },
            { value: 90 },
            { value: 100 },
          ],
          defaultTickValueConfig: {
            formatTextValue: (value: number) => {
              if ([0, 50, 100].includes(value)) {
                return `${value}%`;
              }
              return '';
            },
          },
        },
      }}
      arc={{
        colorArray,
        subArcs,
        padding: 0,
        width: 0.1,
        cornerRadius: 20,
      }}
      pointer={{
        hide: true,
      }}
    />
  );
}

function InfographyLegend({
  items,
  colorScale,
}: {
  items: { score: number; label: string }[];
  colorScale: string[];
}) {
  return (
    <div
      style={{
        float: 'right',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingTop: '12px',
        paddingBottom: '6px',
        paddingLeft: '10px',
        paddingRight: '10px',
        gap: '10px',
        width: '100%',
        border: 1.5,
      }}
    >
      {items.map(({ score, label }) => (
        <div
          key={label}
          style={{
            fontWeight: 500,
            fontSize: '11px',
            display: 'flex',
            color: getFontColorFromPercentage(),
            flexDirection: 'row',
            gap: '5px',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              padding: '2px 7px 4px 7px',
              background: getColorFromPercentage(score, colorScale),
              borderRadius: '12px',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'inline-flex',
            }}
          >
            {displayDecimal(score)}%
          </span>
          <span style={{ color: 'black' }}>{label}</span>
        </div>
      ))}
    </div>
  );
}

function getColorFromPercentage(percentage: number, colorScale: string[]) {
  colorScale = colorScale || ['#3A56A5', '#5F76B5', '#8596C5', '#AAB5D5'];
  if (percentage < 10) {
    return colorScale[3];
  } else if (percentage < 20) {
    return colorScale[2];
  } else if (percentage < 40) {
    return colorScale[1];
  } else {
    return colorScale[0];
  }
}

function getFontColorFromPercentage() {
  return '#FFFFFF';
}
